import React from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";
import { useCompactLayout } from "../responsive";
import MasterToolbar from "./MasterToolbar";

export default function MasterSectionCard({
  title,
  subtitle,
  icon,
  total,
  toolbar,
  children,
  bgcolor = "#e8f3fc",
  bodyPadding = true,
}: {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  total?: number;
  toolbar?: React.ReactNode;
  children: React.ReactNode;
  bgcolor?: string;
  bodyPadding?: boolean;
}) {
  const { containerRef, isCompact } = useCompactLayout();

  return (
    <Paper
      ref={containerRef}
      variant="outlined"
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        "& .rdt_TableBody": {
          marginRight: "0 !important",
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          bgcolor,
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          flexDirection: isCompact ? "column" : "row",
          alignItems: isCompact ? "stretch" : "center",
        }}
      >
        <Box sx={{ flex: "0 1 auto", minWidth: 0 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            {icon}
            <Typography variant="h6" sx={{ fontWeight: 600, color: "#0C2236" }}>
              {title}
            </Typography>
            {typeof total === "number" ? (
              <Chip size="small" label={total} />
            ) : null}
          </Stack>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {toolbar ? <MasterToolbar compact={isCompact}>{toolbar}</MasterToolbar> : null}
      </Box>
      <Box sx={{ p: bodyPadding ? { xs: 1.5, sm: 2 } : 0 }}>{children}</Box>
    </Paper>
  );
}
